import { useState, type ReactNode } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface ContentSectionProps {
  id: string
  heading: string
  contentType?: string
  entityId?: number
  sectionKey?: string
  collapsible?: boolean
  children: ReactNode
}

export function ContentSection({
  id,
  heading,
  collapsible = false,
  children,
}: ContentSectionProps) {
  const [collapsed, setCollapsed] = useState(false)
  // Sections reopen when the page moves to a different entity (ids embed the entity id)
  const [collapsedForId, setCollapsedForId] = useState(id)
  if (collapsedForId !== id) {
    setCollapsedForId(id)
    setCollapsed(false)
  }

  if (!collapsible) {
    return (
      <div className="section-block" id={id}>
        <div className="section-heading">{heading}</div>
        <div className="section-content">{children}</div>
      </div>
    )
  }

  const contentId = `${id}-content`
  return (
    <div className={`section-block section-block--collapsible${collapsed ? ' section-block--collapsed' : ''}`} id={id}>
      <button
        type="button"
        className="section-heading section-heading-toggle"
        aria-expanded={!collapsed}
        aria-controls={contentId}
        onClick={() => setCollapsed((c) => !c)}
      >
        <ExpandMoreIcon className="section-heading-chevron" fontSize="small" />
        {heading}
      </button>
      {/* Hidden rather than unmounted so glossary first-occurrence tracking stays stable */}
      <div className="section-content" id={contentId} hidden={collapsed}>{children}</div>
    </div>
  )
}
